import { isString } from 'lodash';

import S from 'constants/string.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import nullBind from 'utils/functions/nullBind.util';
import withOptions from 'utils/functions/withOptions.util';
import randomString from 'utils/values/randomString.util';

const SEPARATOR = S.minus;

const createNodeKey = withOptions(options => {
  const { unique, index, tag, random } = options;
  const r = isString(options) ? options : random;

  if (r === randomString.LONG || r === randomString.SHORT) return randomString(r);

  const segments = ['key'];

  const t = fromAnyToTrimmed(tag);
  if (t) {
    segments.push(t);
  }

  const trimmed = fromAnyToTrimmed(unique);

  if (trimmed) {
    segments.push('unique', trimmed);

    return segments.join(SEPARATOR);
  }

  if (Number.isFinite(index)) {
    segments.push('index', fromAnyToTrimmed(index));

    return segments.join(SEPARATOR);
  }

  segments.push('random', randomString(randomString.SHORT));

  return segments.join(SEPARATOR);
});

createNodeKey.R_LONG = randomString.LONG;
createNodeKey.R_SHORT = randomString.SHORT;

createNodeKey.long = nullBind(createNodeKey, createNodeKey.R_LONG);
createNodeKey.short = nullBind(createNodeKey, createNodeKey.R_SHORT);

// noinspection JSUnusedGlobalSymbols
export default createNodeKey;
